var t=function(t){return"object"==typeof t&&null!==t&&!(t instanceof Array)&&Object.entries(t).every((function(t){var e=t[0],r=t[1];return"string"==typeof e&&"string"==typeof r}))};export{t as isPrAppUrls};
//# sourceMappingURL=PrAppUrls.js.map
